import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface AdminRedirectProps {
  children: React.ReactNode;
}

/**
 * Redirects admin users to /admin page.
 * Admin users should only see the CRM interface.
 */
const AdminRedirect = ({ children }: AdminRedirectProps) => {
  const { isAdmin, loading, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if authenticated as admin and not already on /admin
    if (!loading && user && isAdmin && location.pathname !== "/admin") {
      navigate("/admin", { replace: true });
    }
  }, [isAdmin, loading, user, navigate, location.pathname]);

  // If admin, don't render children (will be redirected)
  if (!loading && user && isAdmin) {
    return null;
  }

  return <>{children}</>;
};

export default AdminRedirect;
